import React from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import routes from "../../route/routes";
import Footer from "../partials/footer/Footer";
import Nav from "../partials/nav/Nav";

function Dashboard() {
  return (
    <>
      <Nav />
      <Switch>
        {routes.map((route, item) => (
          <Route
            key={item}
            render={route.render}
            path={route.path}
            exact={route.exact}
          />
        ))}
      </Switch>
      <Footer />
    </>
  );
}

export default Dashboard;
